import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { FilterBoxConfiguration } from '../filter-group/filter-box.component';
import { Observable } from 'rxjs/Observable';
import { RxComponent } from 'app/core/components/common/rx.component';


@Component({
  selector: 'itpx-filter-column',
  templateUrl: './filter-column.component.html',
  styleUrls: ['./filter-column.component.css'],
  animations: [
    trigger('openClose',
      [
        state('collapsed', style({ height: '0px' })),
        state('expanded, void', style({ height: '*' })),
        transition(
          'collapsed <=> expanded', animate('0.4s ease-in-out'))
      ]),
    trigger('rotate',
      [
        state('collapsed', style({ transform: 'rotate(90deg)' })),
        state('expanded, void', style({ transform: 'rotate(0deg)' })),
        transition(
          'collapsed <=> expanded', animate('0.4s ease-in-out'))
      ])]
})
export class FilterColumnComponent extends RxComponent implements OnInit {
  @Input() private filters$: Observable<FilterBoxConfiguration[]>;
  @Output() private formStateChange = new EventEmitter<any>();
  // private show: boolean[];
  private stateExpression: string[];
  private filterResults: any;
  private filterInput$: Observable<FilterBoxConfiguration[]>;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.filterInput$ = this.filters$.bindToLifecycle(this).share();
    this.filterInput$.subscribe(filters => {
      this.filterResults = filters.map(filter => ({ key: filter.key, values: null }));
      this.stateExpression = filters.map(val => val.state);
    })
  }

  onFormSubmit(event: any, key: string) {
    this.filterResults.find(filter => filter.key === key).values = this.optionsToString(event);
    let stringifys = this.filterResults
      .filter(val => val.values)
      .map(idx => `@${idx.key}=${idx.values}`)
      .join('&');
    this.formStateChange.emit('&' + stringifys + '&and=1');
  }

  private optionsToString(event: any): string {
    if (Object.keys(event.status)[0] === 'noVoucher')
      return String(event.status['noVoucher']);
    let arr = Object.keys(event.status).filter(i => event.status[i]);
    arr.push('R3S3RV3D');
    return arr.join(',');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filterable-grid/filter-column/filter-column.component.ts